module.exports = __webpack_public_path__ + "img/bg.6e9f5c6f.webp";